export var SignatoryPreviewType;
(function (SignatoryPreviewType) {
    SignatoryPreviewType["Rejected"] = "rejected";
    SignatoryPreviewType["Pending"] = "pending";
    SignatoryPreviewType["Signed"] = "signed";
    SignatoryPreviewType["CC"] = "cc";
})(SignatoryPreviewType || (SignatoryPreviewType = {}));
